import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Toast } from 'primeng/toast';
import { PushNotificationService } from './shared/services/push-notification.service';
import { AuthService } from './shared/services/api/auth.service';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet, TranslateModule, Toast],
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
    private readonly push = inject(PushNotificationService);
    private readonly auth = inject(AuthService);

    // El idioma y su diccionario se eligen y se cargan en el APP_INITIALIZER de
    // app.config, antes de que exista cualquier componente.

    ngOnInit(): void {
        // Start listening to push messages and notification clicks immediately
        this.push.listenToMessages();
        this.push.listenToNotificationClicks();

        // If user is already authenticated on app load, initialise push
        if (this.auth.isAuthenticated()) {
            this.push.init();
        }
    }
}
